import {
  IGNORED_ERRORS,
  isTelemetryActive,
  scrubEvent,
  TRACES_SAMPLE_RATE,
} from "@bezbolisno/kit/telemetry";
import * as Sentry from "@sentry/react";
import { env } from "./env";

/**
 * Browser telemetry, imported first in `main.tsx`. Production only, by code (a DSN alone never
 * opens a socket), no Session Replay — same scrub policy as every other tier. The Mini App
 * shows no clinical data, but a replay would still record a patient's screen.
 */
export const telemetryActive = isTelemetryActive(env.VITE_SENTRY_DSN, env.VITE_SENTRY_ENVIRONMENT);

if (telemetryActive) {
  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.VITE_SENTRY_ENVIRONMENT,
    release: env.VITE_SENTRY_RELEASE,
    tracesSampleRate: TRACES_SAMPLE_RATE,
    beforeSend: (event) => scrubEvent(event),
    ignoreErrors: IGNORED_ERRORS,
  });
}

/** Report a caught failure (the app's failed state). */
export function reportError(error: unknown, context: Record<string, unknown> = {}): void {
  if (telemetryActive) Sentry.captureException(error, { extra: context });
}
